module.exports = __webpack_public_path__ + "img/com.codeway.cleanerplus.15e54439.png";